import React from 'react';
import { Box, Typography } from '@mui/material';
import { isString } from 'lodash';

import { Props } from './props';

const FormHeaderView: React.FC<Props> = (props) => {
  const { title, description, titleProps, descriptionProps, ...rest } = props;
  return (
    <Box {...rest}>
      {isString(title) ? (
        <Typography variant="h6" {...titleProps}>
          {title}
        </Typography>
      ) : (
        title
      )}
      {description && (
        <Typography {...descriptionProps} color={'secondary'} fontSize={14}>
          {description}
        </Typography>
      )}
    </Box>
  );
};

export const FormHeader = FormHeaderView;
export default FormHeaderView;
